/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_OCC_STATEMENTS_ITEM = {
  id: 'statements',
  screenId: 'fin-occ-statements',
  label: 'Resúmenes mensuales',
  description: 'Resumen por período: cuotas, gastos extras y pago del total.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Armás el resumen mensual de cada tarjeta propia: sumás las cuotas de compras hechas con esa tarjeta, agregás cargos del resumen (comisiones, IVA) y registrás el pago desde banco o caja.',
      },
      {
        title: 'De dónde salen las cuotas',
        paragraphs: [
          'Las cuotas no se cargan a mano acá. Surgen cuando registrás un pago con medio «Tarjeta propia» (Finanzas → Pagos u orden de pago): elegís tarjeta, fecha de compra, cantidad de cuotas, primer vencimiento y descripción.',
          'Al crear un resumen podés marcar «Asignar cuotas del período automáticamente» para incluir las cuotas que coincidan con el período. Si cargás pagos después, con el resumen todavía abierto tocá «Recalcular consumos» para sumarlos.',
        ],
      },
      {
        title: 'Paso 1 — Listado de resúmenes',
        fields: [
          { label: 'Tarjeta', description: 'Filtrá por una tarjeta o dejá «Todas».' },
        ],
        bullets: [
          'Columnas: Tarjeta, Período (desde–hasta), Fecha del resumen, Vencimiento, Total, Estado (Abierto / Cerrado).',
          'La lista va del período más reciente al más viejo (por fecha de fin).',
          'Tocá una fila de la lista para abrir el detalle de un resumen.',
          'El botón + abre la ventana de nuevo resumen; primero tenés que elegir una tarjeta (no «Todas»).',
        ],
      },
      {
        title: 'Paso 2 — Crear un resumen',
        intro: 'En «Nuevo resumen» completá:',
        fields: [
          { label: 'Período desde / hasta', description: 'Rango de fechas que cubre el resumen (obligatorio). No puede superponerse con otro resumen activo de la misma tarjeta. Períodos consecutivos sí (ej. 01/09–30/09 y 01/10–31/10).' },
          { label: 'Fecha del resumen', description: 'Fecha de emisión del resumen (obligatoria).' },
          { label: 'Vencimiento', description: 'Fecha límite de pago (opcional).' },
          {
            label: 'Asignar cuotas del período automáticamente',
            description: 'Marcado por defecto. Incluye las cuotas cuya fecha de compra (1ª cuota) o vencimiento cae en el período y aún no están en otro resumen.',
          },
        ],
      },
      {
        title: 'Paso 3 — Detalle del resumen',
        intro: 'Al tocar una fila ves totales y tres bloques:',
        bullets: [
          'Cuotas del período — compras en cuotas asignadas (descripción, nº cuota, vencimiento, monto).',
          'Gastos del resumen — cargos manuales (comisión, IVA, sellos, etc.). Podés agregar con Concepto + Monto + «Agregar gasto», o quitar con X.',
          'Pagos del resumen — movimientos ya registrados desde banco o caja.',
        ],
        paragraphs: [
          'Arriba ves: total cuotas, total gastos, total, pagado, saldo y estado.',
          'Si el resumen está abierto y faltan compras del período, tocá «Recalcular consumos».',
        ],
      },
      {
        title: 'Paso 4 — Registrar el pago',
        intro: 'Con el resumen abierto, en «Registrar pago»:',
        fields: [
          { label: 'Origen del pago', description: 'Banco o Caja.' },
          { label: 'Cuenta bancaria / Caja', description: 'Cuenta o caja autorizada para el egreso.' },
          { label: 'Fecha', description: 'Día del pago.' },
          { label: 'Monto', description: 'Importe pagado.' },
        ],
        paragraphs: [
          '«Pagar» genera el movimiento en banco o caja y reduce el saldo del resumen.',
        ],
      },
      {
        title: 'Cerrar o eliminar',
        bullets: [
          '«Recalcular consumos» — suma al resumen abierto las compras del período que todavía no estaban asignadas.',
          '«Cerrar resumen» — deja el resumen cerrado; ya no se pueden agregar gastos, cuotas ni pagos.',
          '«Eliminar» — solo si el resumen está abierto y no tiene pagos registrados.',
        ],
      },
    ],
  },
}
